import { render, staticRenderFns } from "./ObjectHeader.vue?vue&type=template&id=7e32cc80&scoped=true&"
import script from "./ObjectHeader.vue?vue&type=script&lang=js&"
export * from "./ObjectHeader.vue?vue&type=script&lang=js&"
import style0 from "./ObjectHeader.vue?vue&type=style&index=0&id=7e32cc80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e32cc80",
  null
  
)

export default component.exports